import { render, staticRenderFns } from "./403.vue?vue&type=template&id=30d6ef80"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=30d6ef80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports